import React from "react";
import BranchesMap from "../branches/BranchesMap";
import { branches } from "../../data/branches";

export default function BranchesSection() {
    return (
        <section className="homeBranchesSection">
            <div className="container">
                <h2 className="sectionTitleCenter">Şubelerimiz</h2>
                <p className="sectionSubtitleCenter">
                    Harita üzerinden şubelerimizi inceleyebilirsiniz.
                </p>
            </div>

            <BranchesMap branches={branches} />
        </section>
    );
}
